import { AmagiThemeProvider } from '@amagimedia/amagi-design-system';
import { FC } from 'react';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import { version as bifrostVersion } from '../../../../package.json';
import { version as stvLandingVersion } from '../package.json';
import { SignIn } from './components/SignIn';
import { SigningIn } from './components/SigningIn';
import { SigningOut } from './components/SigningOut';

// TODO: storing the domain and navigating the user to appropriate domain if domain is present

const App: FC = () => {
  return (
    <AmagiThemeProvider stylesPrefix="lan">
      <BrowserRouter>
        <Switch>
          <Route path="/signin" component={SignIn} />
          <Route path="/auth/logout" component={SigningOut} />
          <Route path="/auth" component={SigningIn} />
          <Redirect to={'/signin'} />
        </Switch>
      </BrowserRouter>
    </AmagiThemeProvider>
  );
};

export default App;

console.log(`stv-v2-landing=${stvLandingVersion}; bifrost=${bifrostVersion}`);
